/* import __COLOCATED_TEMPLATE__ from './device-code-redesign.hbs.js'; */
var _dec, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import DevicesSendDeviceCodeModal from '@dashboard/shared-ui/components/devices/send-device-code-modal';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@ember/component';

/**
 ## DevicesDeviceCodeRedesign

  The redesigned sheet for showing device codes. We name this devices/device-code-redesign instead of
  just devices/device-code until we have fully rolled out this sheet for all merchants and can remove
  the old one. See SERVER-914

  ```handlebars
    {{devices/device-code-redesign password=device.password}}
  ```

  ### Parameters
  * @param {String} password - the device code that we split into passwordChunks for readability
  * @param {DeviceType} deviceType - type of device (ie: REGISTER, RESTAURANT, RETAIL)
  * @param {Action} sendDeviceCode - action to call when user attempts to send device code
  * @param {String} sendCodeDescription - description to place in send device code modal
  * @param {hash} jewel - hash with jewel description and src
  * @param {hash} deviceImg - hash with device img description and src
  * @param {Array<Employee>} employees - collection of employees. passed to send-device-code-modal
  * @param {String} downloadAppDescription
  * @param {String} deviceSignInDescription
  * @param {String} sendCodeDescription

  Sass dependencies at: `/dashboard/lib/01-dashboard-shared/addon/styles/dashboard/components/devices/_device-code-redesign.scss`
*/
let DeviceCodeRedesign = (_dec = computed('password'), _class = class DeviceCodeRedesign extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "modal", _descriptor, this);
  }
  /*
    Splits password into chunks of 4
    @returns {Array<String>}
  */
  get passwordChunks() {
    return this.password.match(/.{4}/g);
  }
  triggerSendDeviceCode() {
    this.modal.open(DevicesSendDeviceCodeModal, {
      sendDeviceCode: this.sendDeviceCode,
      description: this.sendCodeDescription,
      employees: this.employees
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "modal", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "passwordChunks", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "passwordChunks"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "triggerSendDeviceCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "triggerSendDeviceCode"), _class.prototype), _class);
export { DeviceCodeRedesign as default };